import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { resetQueries } from '@/utils/api'

import { GET_GUESTS_BASE_QUERY_KEY } from './get-guests'
import { GET_VENDORS_BASE_QUERY_KEY } from './get-vendors'

export type UpdateVisitorStatusRequest = {
  id: number
  type: 'guest' | 'vendor'
  banned?: boolean
  suspended?: boolean
  bannedReason?: string
}

const updateVisitorStatus = async (data: UpdateVisitorStatusRequest): Promise<void> => {
  const { id, ...body } = data
  await authAPI.put(`/visitor/${id}/status`, body)
}

export const useUpdateVisitorStatus = () => {
  return useMutation({
    mutationFn: updateVisitorStatus,
    onSuccess: async () => {
      await resetQueries([GET_GUESTS_BASE_QUERY_KEY], [GET_VENDORS_BASE_QUERY_KEY])
    },
  })
}
